import { EmailModel } from "./Email.model";

export class Email extends EmailModel {
    // Add custom methods here
}
